import React from 'react';
import './HeroSection.css';
import { Primary,Secondary } from '../Constants/Colours';
import eventEmitter from '../../Utils/EventEmitter';


function HeroSection() {

  
  return (
    <div style={{backgroundColor:Primary}} className="Contact-Hero-Section">
      <div style={{borderColor:Secondary}} className="Background-Circle"></div>
      <div className='Contact-Hero-Text-Container'>
        <h1>Contact Us</h1>
        <h2>Contact AAAT today and you can expect to hear back from a representative within a working day</h2>
        <h2 onClick={() => eventEmitter.emit('toggleComplaintModal')} style={{fontSize:'14px',fontStyle:'italic',textDecoration:'underline',cursor:'pointer'}}>Complaints Policy</h2>
      </div>
    </div>
  );
}

export default HeroSection;
